import {ChangeDetectionStrategy, Component} from '@angular/core';

import {TranslatePipe} from '@mydeals/i18n';

@Component({
  selector: 'crm-tenant-form',
  imports: [TranslatePipe],
  templateUrl: './tenant-form.html',
  styleUrl: './tenant-form.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantForm {}
